import i18n from '@/i18n'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/integration/')({
  loader: () => Promise.all([i18n.loadNamespaces('integration')]),
})
